<div>
  <discussion-meta-panel [discussion]="discussion"></discussion-meta-panel>

  <!-- Discussion-panel-start -->
  <div class="card stop-overflow" *ngIf="discussion.panel.length > 0">
    <div class="card-header">
      <h5 class="card-header-text">
        <i class="icofont icofont-tags m-r-10"></i>Discussion panel
      </h5>
    </div>
    <div class="card-body">
      <!-- start panel -->
      <div class="j-span12 j-unit">
        <div *ngFor="let panelMember of discussion.panel" class="media">
          <div class="media-left media-middle photo-table">
            <a [routerLink]="['/profile', panelMember.member.username]">
              <img
                *ngIf="panelMember.member.image"
                class="panel-user-img"
                [src]="panelMember.member.image"
                alt="panel-member"
              />
              <img
                *ngIf="!panelMember.member.image"
                class="panel-user-img"
                [src]="defaultUserImg"
                alt="panel-member"
              />
            </a>
          </div>
          <div class="media-body">
            <a [routerLink]="['/profile', panelMember.member.username]">
              <h6>{{ panelMember.member.username }}</h6>
              <p>
                <span>Bio: </span>
                <span
                  *ngIf="panelMember.member.bio"
                  [innerHTML]="panelMember.member.bio"
                  class="text-muted"
                >
                </span>
              </p>
              <p>
                <label class="j-span2 label label-sm label-primary tagList">
                  Credentials
                </label>
                <span [innerHTML]="panelMember.credential" class="text-muted">
                </span>
              </p>
            </a>
            <hr *ngIf="discussion.panel.length > 1" />
          </div>

          <!-- Panel-credentials-edit -->
          <edit-credential-button
            [currentUser]="currentUser"
            [discussion]="discussion"
            [currentPanelMember]="panelMember"
            [canModifyDiscussion]="canModifyDiscussion"
          >
          </edit-credential-button>
          <!-- Panel-credentials-edit -->

          <!-- Panel-seat-delete -->
          <del-panelSeat-button
            [currentUser]="currentUser"
            [discussion]="discussion"
            [currentPanelMember]="panelMember"
            [canModifyDiscussion]="canModifyDiscussion"
          >
          </del-panelSeat-button>
          <!-- Panel-seat-delete -->
        </div>
      </div>
      <!-- end panel -->
    </div>
  </div>
  <!-- Discussion-panel-end -->

  <!-- Discussion-community-start -->
  <div class="card stop-overflow" *ngIf="discussion.community">
    <div class="card-header">
      <h5 class="card-header-text">
        <i class="icofont icofont-people m-r-10"></i>uMuzi | Community
      </h5>
    </div>
    <div class="card-body">
      <div class="j-span12 j-unit">
        <div class="media">
          <div class="media-left media-middle photo-table">
            <a [routerLink]="['/community', discussion.community.name]">
              <img
                *ngIf="discussion.community.image"
                class="community-image"
                [src]="discussion.community.image"
                alt="community-image"
              />
              <img
                *ngIf="!discussion.community.image"
                class="community-image"
                [src]="defaultCommunityImg"
                alt="community-image"
              />
            </a>
          </div>
          <div class="media-body">
            <a [routerLink]="['/community', discussion.community.name]">
              <h6>{{ discussion.community.name }}</h6>
              <p>
                <span>Summary: </span>
                <span
                  [innerHTML]="discussion.community.summary"
                  class="text-muted"
                >
                </span>
              </p>
            </a>
          </div>
        </div>

        <div class="show-members-button text-center">
          <!-- Community-members-modal -->
          <show-members-button
            *showAuthed="true"
            [community]="discussion.community"
            [limit]="3"
            [config]="{}"
          >
          </show-members-button>
          <!-- Community-members-modal -->
        </div>
      </div>
    </div>
  </div>
  <!-- Discussion-community-end -->

  <!-- Discussion-tags-start -->
  <div class="card stop-overflow" *ngIf="discussion.tagList.length > 0">
    <div class="card-header">
      <h5 class="card-header-text">
        <i class="icofont icofont-tags m-r-10"></i>Discussion tags
      </h5>
    </div>
    <div class="card-body">
      <!-- start tagList -->
      <div class="j-span12 j-unit">
        <span *ngFor="let tag of discussion.tagList">
          <label class="label label-lg label-primary tagList">
            {{ tag | slice: 0:20 }}
          </label>
        </span>
      </div>
      <!-- end tagList -->
    </div>
  </div>
  <!-- Discussion-tags-end -->

  <!-- Discussion-invites-start -->
  <div class="card user-card">
    <div class="card-header">
      <h5 class="card-header-text">
        <i class="icofont icofont-envelope m-r-10"></i>Invites
      </h5>
    </div>

    <div class="invite-to-discussion-section">
      <button
        *ngIf="!canModifyDiscussion"
        type="button"
        class="btn btn-primary invite-to-discussion-button"
        (click)="joinDiscussionPanelAlert()"
      >
        <i class="icofont icofont-plus"></i>
        <i class="icofont icofont-user-alt-2"></i>
        Join panel
      </button>

      <invite-to-discussion-button
        [discussion]="discussion"
        [canModifyDiscussion]="canModifyDiscussion"
      >
      </invite-to-discussion-button>
    </div>
  </div>
  <!-- Discussion-invites-end -->
</div>
